import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { TextMaskCustom } from './TextMaskCustom';
import { TimeInputProps } from './types';

export const TimeInput = React.memo(({ value, rowId, field, onUpdate, mode }: TimeInputProps) => {
    const [localValue, setLocalValue] = useState(value || '');

    useEffect(() => {
        setLocalValue(value || '');
    }, [value]);

    const handleChange = (event: { target: { value: string } }) => {
        const newValue = event.target.value;
        setLocalValue(newValue);
        onUpdate(rowId, field, newValue);
    };

    return (
        <TextField
            sx={{ mt: 0.5 }}
            name={field}
            size="small"
            value={localValue}
            autoComplete="off"
            onChange={handleChange}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            slotProps={{
                htmlInput: {
                    name: field,
                    value: localValue,
                },
                input: {
                    inputComponent: TextMaskCustom as any,
                },
            }}
            disabled={mode === 'info'}
        />
    );
});

TimeInput.displayName = 'TimeInput';
